var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "DeliveryCode-EditTable" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "tabel-warp"
        },
        [
          _c(
            "vxe-table",
            {
              ref: "vxeTable",
              attrs: {
                align: "center",
                border: "",
                data: _vm.tabelData,
                "column-config": _vm.columnConfig,
                "row-config": { isHover: true },
                round: "",
                size: "small",
                "tooltip-config": {
                  showAll: true
                },
                stripe: "",
                "edit-config": _vm.editConfig,
                "keep-source": "",
                "edit-rules": _vm.vxeRules,
                height: "100%"
              }
            },
            [
              _c("vxe-column", {
                attrs: {
                  "min-width": "120",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "editOrderButton",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.handleRowPrint(scope.row)
                              }
                            }
                          },
                          [_vm._v("打印")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "BARCODE",
                  title: "标签条码",
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.BARCODE,
                            callback: function($$v) {
                              _vm.$set(row, "BARCODE", $$v)
                            },
                            expression: "row.BARCODE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NO",
                  title: "物料编码",
                  "min-width": "160",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NO,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NO", $$v)
                            },
                            expression: "row.PART_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NAME",
                  title: "物料名称",
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NAME,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NAME", $$v)
                            },
                            expression: "row.PART_NAME"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_DESCR",
                  title: "规格描述",
                  "min-width": "180",
                  "show-overflow": "ellipsis",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_DESCR,
                            callback: function($$v) {
                              _vm.$set(row, "PART_DESCR", $$v)
                            },
                            expression: "row.PART_DESCR"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PACKING_QTY",
                  title: "装箱单位数量",
                  "min-width": "120",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PACKING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PACKING_QTY", $$v)
                            },
                            expression: "row.PACKING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "QTY",
                  title: "最小包装",
                  "min-width": "120",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_REMAINING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PO_REMAINING_QTY", $$v)
                            },
                            expression: "row.PO_REMAINING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "TOTAL_QTY",
                  title: "送货数量",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.SPQ,
                            callback: function($$v) {
                              _vm.$set(row, "SPQ", $$v)
                            },
                            expression: "row.SPQ"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_UNIT",
                  title: "采购单位",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.PO_UNIT,
                            callback: function($$v) {
                              _vm.$set(row, "PO_UNIT", $$v)
                            },
                            expression: "row.PO_UNIT"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "BASE_UNIT",
                  title: "基本单位",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.PO_UNIT,
                            callback: function($$v) {
                              _vm.$set(row, "PO_UNIT", $$v)
                            },
                            expression: "row.PO_UNIT"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "UNIT_EXRATE",
                  title: "转换基准",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.UNIT_EXRATE,
                            callback: function($$v) {
                              _vm.$set(row, "UNIT_EXRATE", $$v)
                            },
                            expression: "row.UNIT_EXRATE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  formatter: _vm.vxeFormatDate,
                  field: "DATE_CODE",
                  title: "生产日期",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.DATE_CODE,
                            callback: function($$v) {
                              _vm.$set(row, "DATE_CODE", $$v)
                            },
                            expression: "row.DATE_CODE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "LOT_NO",
                  title: "批次号",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.LOT_NO,
                            callback: function($$v) {
                              _vm.$set(row, "LOT_NO", $$v)
                            },
                            expression: "row.LOT_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("changeOrderDialog", {
        ref: "changeOrderDialog",
        attrs: { isShowChangeOrderDialog: _vm.isShowChangeOrderDialog },
        on: {
          closeChangeOrderDialog: _vm.closeChangeOrderDialog,
          cbDialogSubmit: _vm.cbDialogSubmit
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }